import axios from 'axios'
// import router from '../router'

import Config from '@/config'

console.log('Initializing Http [axios]')

export default axios.create({
  baseURL: `${Config.apiRoot}`,
  timeout: 12000,
  headers: {
    // 'Authorization': `Token ${TOKEN}`
  }
})

console.log('Initialized Http [axios]')
